const environment = import.meta.env || {};
const configuredSiteUrl = environment.VITE_SITE_URL?.replace(/\/$/, '');

export const siteUrl = configuredSiteUrl || 'https://aitsmena.com';
export const apiUrl = `${siteUrl}/api/v1`;
export const storageUrl = `${siteUrl}/storage`;
